import React from 'react'
import './testimonials.css'
import AVTR1 from '../../assets/avatar1.jpg'
import AVTR2 from '../../assets/avatar2.jpg'
import AVTR3 from '../../assets/avatar3.jpg'
import AVTR4 from '../../assets/avatar4.jpg'

// import Swiper core and required modules
import {Pagination} from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const data = [
  {
    avatar: AVTR1,
    name: 'Flandra Sadiku',
    review: 'Very helpful when building my website, I now have my ecommerce store built from scratch'
  },
  {
    avatar: AVTR2,
    name: 'Endrit',
    review: 'Albert was very helpful and fast to respond to my inquiry to help with my website issues.  His knowledge was comprehensive.'
  },
  {
    avatar: AVTR3,
    name: 'Eric',
    review: 'Fantastic service and great guy. We recommend to anyone who needs a website or web services. Well be using for any further web based services we require!'
  },

]

const Testimonials = () => {
  return (
    <section id='testimonials'>
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper className="container testimonials__container" 
      // install Swiper modules
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}>
        {
          data.map(({avatar, name, review}, index) => {
            return (
              <SwiperSlide key={index} className='testimonial'>
              <div className="client__avatar">
                <img src={avatar}/>
              </div>
              <h5 className='client__name'>{name}</h5>
              <small className='client__review'>{review}</small>
              </SwiperSlide> 
            )
          })
        }
      </Swiper>
    </section>
  )
}

export default Testimonials